import {
  Box,
  Button,
  Dialog,
  IconButton,
  Paper,
  DialogActions,
  DialogContent,
  DialogTitle,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Popover,
  Checkbox,
  Typography,
  Autocomplete,
  Menu,
  MenuItem,
  Divider,
  CircularProgress,
  Chip,
  Collapse,
  Grid,
} from "@mui/material";
import {
  Delete as DeleteIcon,
  Edit,
  Print,
  ExpandMore,
  ExpandLess,
  Description as FileIcon,
  Close as CloseIcon,
  Visibility,
} from "@mui/icons-material";
import { Tooltip } from "@mui/material";
import { useNavigate } from "react-router-dom";
import AddIcon from "@mui/icons-material/Add";
import { useState, useEffect } from "react";
import { ToastContainer } from "react-toastify";
import InfiniteScroll from "react-infinite-scroll-component";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { useMediaQuery, useTheme } from "@mui/material";
import {
  ProformaInvoiceExportApi,
  ProformaInvoiceListApi,
  ProformaInvoiceDelete,
  ApproveProformaInvoice,
  DivisionList,
} from "../../../Services/Services";
import { printPerforma } from "./performaPrint";

const ProformaInvoiceTable = () => {
  const stored = localStorage.getItem("selectedDivision");
  const divisionLocalStorage = JSON.parse(stored);
  const [filters, setFilters] = useState({
    division: "",
    pi_no: "",
    project_name: "",
    date_range: "this_month",
    pi_date_from: "",
    pi_date_to: "",
  });

  const theme = useTheme();
  const isDark = theme.palette.mode === "dark";
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [expandedPI, setExpandedPI] = useState(null);

  const [piDateMenuAnchor, setPiDateMenuAnchor] = useState(null);
  const [piDateRange, setPiDateRange] = useState({ from: "", to: "" });
  const [tempPiDateRange, setTempPiDateRange] = useState({ from: "", to: "" });

  const [proformas, setProformas] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [invoiceToDelete, setInvoiceToDelete] = useState(null);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const navigate = useNavigate();
  const [piToApprove, setPIToApprove] = useState(null);
  const [remarkInput, setRemarkInput] = useState("");
  const userRole = localStorage.getItem("role");
  const [divisionLists, setDivisionLists] = useState([]);
  const [dateMenuAnchor, setDateMenuAnchor] = useState(null);
  const [isExcelLoading, setExcelLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [approvalDialogOpen, setApprovalDialogOpen] = useState(false);
  const [filterLoading, setFilterLoading] = useState(false);
  const [showCustomDateInputs, setShowCustomDateInputs] = useState(false);
  const [tempCustomDateRange, setTempCustomDateRange] = useState({
    from: "",
    to: "",
  });
  const [customDateRange, setCustomDateRange] = useState({ from: "", to: "" });

  // ----- enhanced styles with dark mode support -----
  const getStyles = () => ({
    table: {
      width: "100%",
      borderCollapse: "collapse",
      fontFamily: "Arial, sans-serif",
      fontSize: "11px",
      color: theme.palette.text.primary,
    },
    cell: {
      border: `1px solid ${theme.palette.divider}`,
      padding: "4px 6px",
      verticalAlign: "top",
      lineHeight: "1.4",
    },
    headerCell: {
      border: `1px solid ${theme.palette.divider}`,
      padding: "4px 6px",
      fontWeight: "bold",
      textAlign: "center",
      backgroundColor: isDark ? theme.palette.grey[800] : "#fff",
      verticalAlign: "middle",
    },
    bold: {
      fontWeight: "bold",
    },
    redHeader: {
      color: theme.palette.error.main,
      textAlign: "center",
      fontWeight: "bold",
      fontSize: "18px",
      padding: "10px",
      border: `1px solid ${theme.palette.divider}`,
      borderBottom: "none",
    },
  });

  // ----- API handlers -----
  const handleExcelExport = async () => {
    if (proformas.length === 0) {
      toast.warning("No data available to export");
      return;
    }

    setExcelLoading(true);
    try {
      const params = { ...filters };
      if (
        filters.date_range === "custom" &&
        customDateRange.from &&
        customDateRange.to
      ) {
        params.from_date = customDateRange.from;
        params.to_date = customDateRange.to;
      }

      if (filters.pi_date_from && filters.pi_date_to) {
        params.pi_date_from = filters.pi_date_from;
        params.pi_date_to = filters.pi_date_to;
      }

      const blob = await ProformaInvoiceExportApi(params);
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `Proforma_Invoices_${new Date().getTime()}.xlsx`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);

      toast.success("Excel downloaded successfully!");
    } catch (error) {
      console.error("Export error:", error);
      toast.error("Failed to export Excel");
    } finally {
      setExcelLoading(false);
    }
  };

  useEffect(() => {
    const fetchDivisions = async () => {
      try {
        const divisions = await DivisionList();
        setDivisionLists(
          Array.isArray(divisions) ? divisions : divisions?.results || []
        );
      } catch (error) {
        console.error("Error fetching divisions:", error);
        toast.error("Failed to load divisions");
      }
    };
    fetchDivisions();
  }, []);

  useEffect(() => {
    const handler = setTimeout(() => {
      setPage(1);
      fetchProformas(1, filters, true);
    }, 500);

    return () => clearTimeout(handler);
  }, [filters, customDateRange, piDateRange]);

  const fetchProformas = async (
    pageNum = 1,
    filterObj = filters,
    reset = false
  ) => {
    try {
      if (reset) {
        setFilterLoading(true);
      } else {
        setLoading(true);
      }
      const params = { ...filterObj };

      if (
        filterObj.date_range === "custom" &&
        customDateRange.from &&
        customDateRange.to
      ) {
        params.from_date = customDateRange.from;
        params.to_date = customDateRange.to;
      }

      if (filterObj.pi_date_from && filterObj.pi_date_to) {
        params.pi_date_from = filterObj.pi_date_from;
        params.pi_date_to = filterObj.pi_date_to;
      }

      const res = await ProformaInvoiceListApi(pageNum, params);

      if (reset || pageNum === 1) {
        setProformas(res.results || []);
      } else {
        setProformas((prev) => [...prev, ...(res.results || [])]);
      }

      setHasMore(res.next !== null);
      setPage(pageNum);
    } catch (error) {
      console.error("❌ Failed to fetch sales orders:", error);
      toast.error("Failed to load sales orders");
    } finally {
      setFilterLoading(false);
      setLoading(false);
    }
  };

  const fetchMoreData = () => {
    if (!hasMore) return;
    const nextPage = page + 1;
    fetchProformas(nextPage, filters);
  };

  const executeApproval = async (status) => {
    if (status === "Rejected" && !remarkInput.trim()) {
      toast.error("Remark is required for rejection!");
      return;
    }

    const approvedById = Number(localStorage.getItem("user_id"));
    if (!approvedById) {
      toast.error("Approver ID not found.");
      return;
    }

    const piId =
      piToApprove?.invoice_number || piToApprove?.invoice?.invoice_number;
    if (!piId) {
      toast.error("PI ID is undefined.");
      return;
    }

    try {
      await ApproveProformaInvoice(piId, approvedById, status, remarkInput);

      const updatedList = await ProformaInvoiceListApi(1, filters);
      setProformas(updatedList.results || []);

      toast.success(
        status === "Approved"
          ? "PI approved successfully!"
          : "PI rejected successfully!"
      );

      setApprovalDialogOpen(false);
      setRemarkInput("");
      setPIToApprove(null);
    } catch (error) {
      console.error("Approval Error:", error);
      toast.error("Failed to process approval.");
    }
  };

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({ ...prev, [name]: value }));
  };

  const handleReset = () => {
    setFilters({
      division: "",
      pi_no: "",
      project_name: "",
      date_range: "today",
      pi_date_from: "",
      pi_date_to: "",
    });
    setCustomDateRange({ from: "", to: "" });
    setPage(1);
    setTempCustomDateRange({ from: "", to: "" });
    setShowCustomDateInputs(false);
    setPiDateRange({ from: "", to: "" });
    setTempPiDateRange({ from: "", to: "" });
  };

  const handleCancelCustomDateRange = () => {
    setTempCustomDateRange({ from: "", to: "" });
    setShowCustomDateInputs(false);
  };

  const handleApplyCustomDateRange = () => {
    if (tempCustomDateRange.from && tempCustomDateRange.to) {
      setCustomDateRange({
        from: tempCustomDateRange.from,
        to: tempCustomDateRange.to,
      });
      setFilters((prev) => ({ ...prev, date_range: "custom" }));
      setDateMenuAnchor(null);
      setShowCustomDateInputs(false);
    } else {
      toast.warning("Please select both From and To dates");
    }
  };

  const handleDelete = async (invoiceNumber) => {
    if (!invoiceNumber) {
      toast.error("Invalid invoice number.");
      return;
    }

    try {
      const res = await ProformaInvoiceDelete(invoiceNumber);

      if (res && res.message !== "Not found") {
        toast.success("Invoice deleted successfully.");
        const data = await ProformaInvoiceListApi();
        setProformas(data.results || []);
      } else {
        toast.error("Failed to delete invoice.");
      }
    } catch (error) {
      console.error("Delete error:", error);
      toast.error("Failed to delete invoice.");
    }
    setAnchorEl(null);
  };

  const truncateText = (text, limit = 20) => {
    if (!text) return "";
    return text.length > limit ? text.substring(0, limit) + "..." : text;
  };

  function formatOnlyDate(dateTimeString) {
    if (!dateTimeString) return "N/A";
    const datePart = dateTimeString.split("T")[0];
    const [year, month, day] = datePart.split("-");
    return `${day}-${month}-${year}`;
  }

  const formatDateDisplay = (dateString) => {
    if (!dateString) return "";
    const [year, month, day] = dateString.split("-");
    return `${day}-${month}-${year}`;
  };

  const getDateRangeDisplay = (rangeType) => {
    const now = new Date();
    const formatDate = (date) => {
      const day = date.getDate().toString().padStart(2, "0");
      const month = (date.getMonth() + 1).toString().padStart(2, "0");
      const year = date.getFullYear();
      return `${day}-${month}-${year}`;
    };

    switch (rangeType) {
      case "today":
        return formatDate(now);
      case "yesterday": {
        const yesterday = new Date(now);
        yesterday.setDate(yesterday.getDate() - 1);
        return formatDate(yesterday);
      }
      case "this_week": {
        const weekStart = new Date(now);
        weekStart.setDate(weekStart.getDate() - weekStart.getDay() + 1);
        return `${formatDate(weekStart)} to ${formatDate(now)}`;
      }
      case "previous_week": {
        const prevWeekEnd = new Date(now);
        prevWeekEnd.setDate(prevWeekEnd.getDate() - prevWeekEnd.getDay());
        const prevWeekStart = new Date(prevWeekEnd);
        prevWeekStart.setDate(prevWeekStart.getDate() - 6);
        return `${formatDate(prevWeekStart)} to ${formatDate(prevWeekEnd)}`;
      }
      case "this_month": {
        const monthStart = new Date(now.getFullYear(), now.getMonth(), 1);
        return `${formatDate(monthStart)} to ${formatDate(now)}`;
      }
      case "current_year": {
        const yearStart = new Date(now.getFullYear(), 0, 1);
        return `${formatDate(yearStart)} to ${formatDate(now)}`;
      }
      case "financial_year": {
        let fyStart;
        if (now.getMonth() >= 3) {
          fyStart = new Date(now.getFullYear(), 3, 1);
        } else {
          fyStart = new Date(now.getFullYear() - 1, 3, 1);
        }
        return `${formatDate(fyStart)} to ${formatDate(now)}`;
      }
      default:
        return "";
    }
  };

  const handleApplyPiDateRange = () => {
    setPiDateRange(tempPiDateRange);
    setFilters((prev) => ({
      ...prev,
      pi_date_from: tempPiDateRange.from,
      pi_date_to: tempPiDateRange.to,
      date_range: "all",
    }));
    setPiDateMenuAnchor(null);
  };

  const handleCancelPiDateRange = () => {
    setTempPiDateRange(piDateRange);
    setPiDateMenuAnchor(null);
  };

  const handleClearPiDateRange = () => {
    setPiDateRange({ from: "", to: "" });
    setTempPiDateRange({ from: "", to: "" });
    setFilters((prev) => ({
      ...prev,
      pi_date_from: "",
      pi_date_to: "",
    }));
    setPiDateMenuAnchor(null);
  };

  // ----- Mobile Card Component with dark mode awareness -----
  const MobileProformaCard = ({ invoice, index }) => {
    const isExpanded = expandedPI === invoice.invoice_number;
    const cardBg = index % 2 === 0 ? theme.palette.background.default : theme.palette.background.paper;

    return (
      <Box key={invoice.invoice_number}>
        <Box
          onClick={() =>
            setExpandedPI(
              expandedPI === invoice.invoice_number
                ? null
                : invoice.invoice_number
            )
          }
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            p: 1.5,
            cursor: "pointer",
            bgcolor: cardBg,
            "&:hover": {
              bgcolor: isDark ? theme.palette.grey[800] : "#e3f2fd",
            },
            borderLeft: `4px solid ${
              invoice.status === "Approved"
                ? theme.palette.success.main
                : invoice.status === "Rejected"
                ? theme.palette.error.main
                : theme.palette.warning.main
            }`,
            transition: "background-color 0.2s",
          }}
        >
          <Box sx={{ flex: 1 }}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 0.5 }}>
              <Typography
                sx={{ fontSize: "0.7rem", color: theme.palette.text.secondary, minWidth: 25 }}
              >
                #{index + 1}
              </Typography>
              <Typography
                sx={{ fontWeight: "bold", fontSize: "0.85rem", flex: 1, color: theme.palette.text.primary }}
              >
                {invoice.pi_no || "N/A"}
              </Typography>
            </Box>

            <Typography
              sx={{
                fontSize: "0.75rem",
                color: theme.palette.text.secondary,
                display: "flex",
                alignItems: "center",
                gap: 1,
              }}
            >
              <span style={{ fontWeight: 500 }}>
                {invoice.project?.party_details?.company_name?.substring(
                  0,
                  20
                ) || "N/A"}
              </span>
              <span style={{ color: theme.palette.text.disabled }}>•</span>
              <span style={{ fontSize: "0.7rem" }}>
                {formatOnlyDate(invoice.created_at)}
              </span>
            </Typography>
          </Box>

          <IconButton size="small" sx={{ ml: 1, color: theme.palette.text.secondary }}>
            {isExpanded ? <ExpandLess fontSize="small" /> : <ExpandMore fontSize="small" />}
          </IconButton>
        </Box>

        <Collapse in={isExpanded} timeout="auto" unmountOnExit>
          <Box
            sx={{
              px: 1.5,
              py: 1,
              bgcolor: isDark ? theme.palette.grey[900] : "#f8f9fa",
              borderLeft: `4px solid ${
                invoice.status === "Approved"
                  ? theme.palette.success.main
                  : invoice.status === "Rejected"
                  ? theme.palette.error.main
                  : theme.palette.warning.main
              }`,
            }}
          >
            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gap: 0.8,
                mb: 1,
              }}
            >
              <Box>
                <Typography
                  sx={{
                    fontSize: "0.6rem",
                    color: theme.palette.text.secondary,
                    letterSpacing: "0.5px",
                  }}
                >
                  STATUS
                </Typography>
                <Chip
                  label={invoice.status || "Pending"}
                  color={
                    invoice.status === "Approved"
                      ? "success"
                      : invoice.status === "Rejected"
                      ? "error"
                      : "warning"
                  }
                  size="small"
                  sx={{ height: 20, fontSize: "0.65rem", mt: 0.3 }}
                />
              </Box>

              <Box>
                <Typography
                  sx={{
                    fontSize: "0.6rem",
                    color: theme.palette.text.secondary,
                    letterSpacing: "0.5px",
                  }}
                >
                  PI AMOUNT
                </Typography>
                <Typography
                  sx={{
                    fontSize: "0.75rem",
                    fontWeight: 600,
                    color: theme.palette.success.main,
                  }}
                >
                  ₹{" "}
                  {Number(invoice.advance_received || 0).toLocaleString(
                    "en-IN",
                    {
                      minimumFractionDigits: 1,
                      maximumFractionDigits: 1,
                    }
                  )}
                </Typography>
              </Box>

              <Box>
                <Typography
                  sx={{
                    fontSize: "0.6rem",
                    color: theme.palette.text.secondary,
                    letterSpacing: "0.5px",
                  }}
                >
                  RECEIVED
                </Typography>
                <Typography
                  sx={{
                    fontSize: "0.72rem",
                    fontWeight: 500,
                    color: theme.palette.primary.main,
                  }}
                >
                  ₹{" "}
                  {Number(invoice.receive_amt || 0).toLocaleString("en-IN", {
                    minimumFractionDigits: 1,
                    maximumFractionDigits: 1,
                  })}
                </Typography>
              </Box>

              {invoice.created_by_po && (
                <Box>
                  <Typography
                    sx={{
                      fontSize: "0.6rem",
                      color: theme.palette.text.secondary,
                      letterSpacing: "0.5px",
                    }}
                  >
                    CREATED BY
                  </Typography>
                  <Typography
                    sx={{ fontSize: "0.72rem", fontWeight: 500, color: theme.palette.text.primary }}
                  >
                    {invoice.created_by_po}
                  </Typography>
                </Box>
              )}
            </Box>

            {invoice.project?.project_name && (
              <Box sx={{ mb: 0.8 }}>
                <Typography
                  sx={{
                    fontSize: "0.6rem",
                    color: theme.palette.text.secondary,
                    letterSpacing: "0.5px",
                    mb: 0.3,
                  }}
                >
                  PROJECT
                </Typography>
                <Typography
                  sx={{
                    fontSize: "0.7rem",
                    color: theme.palette.text.primary,
                    lineHeight: 1.3,
                    display: "-webkit-box",
                    WebkitLineClamp: 2,
                    WebkitBoxOrient: "vertical",
                    overflow: "hidden",
                  }}
                >
                  {invoice.project.project_name}
                </Typography>
              </Box>
            )}

            <Divider sx={{ my: 1, borderColor: theme.palette.divider }} />

            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                gap: 1,
              }}
            >
              {userRole !== "Staff" && (
                <IconButton
                  size="small"
                  onClick={(e) => {
                    e.stopPropagation();
                    setPIToApprove(invoice);
                    setApprovalDialogOpen(true);
                  }}
                  sx={{
                    bgcolor: isDark ? theme.palette.grey[700] : "#e3f2fd",
                    borderRadius: "6px",
                    width: 32,
                    height: 32,
                    "&:hover": { bgcolor: isDark ? theme.palette.grey[600] : "#bbdefb" },
                  }}
                >
                  <Visibility sx={{ fontSize: "1rem", color: theme.palette.primary.main }} />
                </IconButton>
              )}
              <Box
                sx={{
                  display: "flex",
                  flexWrap: "wrap",
                  justifyContent: "flex-end",
                  alignItems: "center",
                  gap: 0.8,
                  mt: 1,
                  pt: 1,
                  borderTop: `1px solid ${theme.palette.divider}`,
                }}
              >
                <IconButton
                  size="small"
                  onClick={(e) => {
                    e.stopPropagation();
                    navigate(`/dashboard/performaInvoice/${invoice.invoice_number}`, {
                      state: { invoice },
                    });
                  }}
                  sx={{
                    bgcolor: isDark ? theme.palette.grey[700] : "#e8f5e9",
                    borderRadius: "6px",
                    width: 36,
                    height: 36,
                    "&:hover": { bgcolor: isDark ? theme.palette.grey[600] : "#c8e6c9" },
                  }}
                >
                  <Edit sx={{ fontSize: "1.1rem", color: theme.palette.success.main }} />
                </IconButton>

                <IconButton
                  size="small"
                  onClick={(e) => {
                    e.stopPropagation();
                    setAnchorEl(e.currentTarget);
                    setInvoiceToDelete(invoice.invoice_number);
                  }}
                  sx={{
                    bgcolor: isDark ? theme.palette.grey[700] : "#ffebee",
                    borderRadius: "6px",
                    width: 36,
                    height: 36,
                    "&:hover": { bgcolor: isDark ? theme.palette.grey[600] : "#ffcdd2" },
                  }}
                >
                  <DeleteIcon sx={{ fontSize: "1.1rem", color: theme.palette.error.main }} />
                </IconButton>

                <IconButton
                  size="small"
                  onClick={(e) => {
                    e.stopPropagation();
                    printPerforma(invoice);
                  }}
                  sx={{
                    bgcolor: isDark ? theme.palette.grey[700] : "#fff3e0",
                    borderRadius: "6px",
                    width: 36,
                    height: 36,
                    "&:hover": { bgcolor: isDark ? theme.palette.grey[600] : "#ffe0b2" },
                  }}
                >
                  <Print sx={{ fontSize: "1.1rem", color: theme.palette.warning.main }} />
                </IconButton>
              </Box>
            </Box>
          </Box>
        </Collapse>

        <Divider sx={{ borderColor: theme.palette.divider }} />
      </Box>
    );
  };

  // ----- Main render -----
  const styles = getStyles();

  return (
    <>
      <Box sx={{ mt: { xs: 4.1, md: 3 }, pt: -3, mb: 2, width: "100%" }}>
        <ToastContainer position="top-right" autoClose={3000} />

        {/* DESKTOP VIEW */}
        <Box
          sx={{
            display: { xs: "none", md: "flex" },
            gap: 2,
            flexWrap: "wrap",
            alignItems: "center",
          }}
        >
          <TextField
            label="Date Range"
            value={
              filters.date_range === "custom" &&
              customDateRange.from &&
              customDateRange.to
                ? `${formatDateDisplay(
                    customDateRange.from
                  )} to ${formatDateDisplay(customDateRange.to)}`
                : filters.date_range === "today"
                ? "Today"
                : filters.date_range === "yesterday"
                ? "Yesterday"
                : filters.date_range === "this_week"
                ? "This Week"
                : filters.date_range === "previous_week"
                ? "Previous Week"
                : filters.date_range === "this_month"
                ? "This Month"
                : filters.date_range === "current_year"
                ? "Current Year"
                : filters.date_range === "financial_year"
                ? "Financial Year"
                : "Select Date Range"
            }
            onClick={(e) => setDateMenuAnchor(e.currentTarget)}
            size="small"
            InputProps={{
              readOnly: true,
              endAdornment: (
                <IconButton size="small" edge="end">
                  <ArrowDropDownIcon />
                </IconButton>
              ),
            }}
            sx={{
              flex: "1 1 100px",
              cursor: "pointer",
              "& .MuiInputBase-root": { height: 35, borderRadius: 0 },
              "& .MuiInputLabel-root": { fontSize: "0.65rem" },
            }}
          />

          <TextField
            label="Search by Project Name"
            name="project_name"
            value={filters.project_name}
            onChange={handleFilterChange}
            size="small"
            sx={{
              flex: "1 1 100px",
              "& .MuiInputBase-root": { height: 35, borderRadius: 0 },
              "& .MuiInputLabel-root": { fontSize: "0.65rem" },
            }}
          />

          <TextField
            label="PI Date"
            value={
              piDateRange.from && piDateRange.to
                ? `${formatDateDisplay(
                    piDateRange.from
                  )} to ${formatDateDisplay(piDateRange.to)}`
                : piDateRange.from
                ? `From ${formatDateDisplay(piDateRange.from)}`
                : piDateRange.to
                ? `To ${formatDateDisplay(piDateRange.to)}`
                : ""
            }
            placeholder="Select PI Date Range"
            onClick={(e) => {
              setPiDateMenuAnchor(e.currentTarget);
              setTempPiDateRange(piDateRange);
            }}
            size="small"
            InputProps={{
              readOnly: true,
              endAdornment: (
                <IconButton size="small" edge="end">
                  <ArrowDropDownIcon />
                </IconButton>
              ),
            }}
            InputLabelProps={{ shrink: true }}
            sx={{
              flex: "1 1 100px",
              cursor: "pointer",
              "& .MuiInputBase-root": { height: 35, borderRadius: 0 },
              "& .MuiInputLabel-root": { fontSize: "0.65rem" },
              "& .MuiInputBase-input": { cursor: "pointer" },
            }}
          />

          <Menu
            anchorEl={piDateMenuAnchor}
            open={Boolean(piDateMenuAnchor)}
            onClose={handleCancelPiDateRange}
            PaperProps={{ sx: { width: 320, p: 0 } }}
          >
            <Box
              sx={{ px: 2, py: 2, bgcolor: isDark ? theme.palette.grey[900] : "#fafafa" }}
              onClick={(e) => e.stopPropagation()}
            >
              <Typography
                variant="subtitle2"
                sx={{ mb: 2, fontWeight: 600, color: theme.palette.primary.main }}
              >
                Select PI Date Range
              </Typography>

              <Box sx={{ display: "flex", gap: 1, mb: 2 }}>
                <TextField
                  label="From Date"
                  type="date"
                  size="small"
                  fullWidth
                  value={tempPiDateRange.from}
                  onChange={(e) =>
                    setTempPiDateRange((prev) => ({
                      ...prev,
                      from: e.target.value,
                    }))
                  }
                  InputLabelProps={{ shrink: true }}
                  inputProps={{
                    max:
                      tempPiDateRange.to ||
                      new Date().toISOString().split("T")[0],
                  }}
                  sx={{
                    flex: 1,
                    "& .MuiInputBase-root": { height: 40, fontSize: "0.75rem" },
                    "& .MuiInputLabel-root": { fontSize: "0.75rem" },
                  }}
                />

                <TextField
                  label="To Date"
                  type="date"
                  size="small"
                  fullWidth
                  value={tempPiDateRange.to}
                  onChange={(e) =>
                    setTempPiDateRange((prev) => ({
                      ...prev,
                      to: e.target.value,
                    }))
                  }
                  InputLabelProps={{ shrink: true }}
                  inputProps={{
                    min: tempPiDateRange.from || undefined,
                    max: new Date().toISOString().split("T")[0],
                  }}
                  sx={{
                    flex: 1,
                    "& .MuiInputBase-root": { height: 40, fontSize: "0.75rem" },
                    "& .MuiInputLabel-root": { fontSize: "0.75rem" },
                  }}
                />
              </Box>

              {tempPiDateRange.from && tempPiDateRange.to && (
                <Typography
                  variant="caption"
                  sx={{
                    display: "block",
                    mb: 2,
                    p: 1,
                    bgcolor: isDark ? theme.palette.grey[800] : "#e8f5e9",
                    borderRadius: 1,
                    textAlign: "center",
                    color: theme.palette.success.main,
                    fontWeight: 500,
                  }}
                >
                  📅 {formatDateDisplay(tempPiDateRange.from)} to{" "}
                  {formatDateDisplay(tempPiDateRange.to)}
                </Typography>
              )}

              <Box
                sx={{
                  display: "flex",
                  gap: 1,
                  justifyContent: "space-between",
                }}
              >
                <Button
                  variant="text"
                  size="small"
                  color="error"
                  onClick={handleClearPiDateRange}
                  disabled={!piDateRange.from && !piDateRange.to}
                  sx={{ fontSize: "0.7rem", textTransform: "none" }}
                >
                  Clear
                </Button>

                <Box sx={{ display: "flex", gap: 1 }}>
                  <Button
                    variant="outlined"
                    size="small"
                    onClick={handleCancelPiDateRange}
                    sx={{
                      fontSize: "0.7rem",
                      textTransform: "none",
                      borderRadius: 1,
                    }}
                  >
                    Cancel
                  </Button>
                  <Button
                    variant="contained"
                    size="small"
                    onClick={handleApplyPiDateRange}
                    disabled={!tempPiDateRange.from || !tempPiDateRange.to}
                    sx={{
                      fontSize: "0.7rem",
                      textTransform: "none",
                      borderRadius: 1,
                    }}
                  >
                    Apply
                  </Button>
                </Box>
              </Box>
            </Box>
          </Menu>

          <Button
            variant="contained"
            color="primary"
            size="small"
            onClick={handleReset}
            sx={{
              height: "35px",
              whiteSpace: "nowrap",
              minWidth: "70px",
              borderRadius: 0,
              fontSize: "0.7rem",
            }}
          >
            Reset
          </Button>

          <Button
            variant="contained"
            color="primary"
            onClick={() => navigate("/dashboard/performaInvoice")}
            startIcon={<AddIcon fontSize="small" />}
            sx={{
              height: 35,
              minWidth: 100,
              fontSize: "0.7rem",
              borderRadius: 0,
              whiteSpace: "nowrap",
            }}
          >
            Proforma Invoice
          </Button>

          <IconButton
            onClick={handleExcelExport}
            disabled={isExcelLoading || proformas.length === 0}
            sx={{
              height: 35,
              width: 35,
              bgcolor: theme.palette.success.main,
              color: "white",
              borderRadius: 0,
              "&:hover": { bgcolor: theme.palette.success.dark },
              "&:disabled": { bgcolor: theme.palette.grey[400], color: "white" },
            }}
          >
            {isExcelLoading ? (
              <CircularProgress size={18} color="inherit" />
            ) : (
              <FileIcon fontSize="small" />
            )}
          </IconButton>
        </Box>

        {/* MOBILE VIEW */}
        <Box sx={{ display: { xs: "block", md: "none" } }}>
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: { xs: "1fr", sm: "repeat(2, 1fr)" },
              gap: 1.5,
              mb: 1.5,
            }}
          >
            <TextField
              label="Date Range"
              value={
                filters.date_range === "custom" &&
                customDateRange.from &&
                customDateRange.to
                  ? `${formatDateDisplay(
                      customDateRange.from
                    )} to ${formatDateDisplay(customDateRange.to)}`
                  : filters.date_range === "today"
                  ? "Today"
                  : filters.date_range === "yesterday"
                  ? "Yesterday"
                  : filters.date_range === "this_week"
                  ? "This Week"
                  : filters.date_range === "previous_week"
                  ? "Previous Week"
                  : filters.date_range === "this_month"
                  ? "This Month"
                  : filters.date_range === "current_year"
                  ? "Current Year"
                  : filters.date_range === "financial_year"
                  ? "Financial Year"
                  : "Select Date Range"
              }
              onClick={(e) => setDateMenuAnchor(e.currentTarget)}
              size="small"
              fullWidth
              InputProps={{
                readOnly: true,
                endAdornment: (
                  <IconButton size="small" edge="end">
                    <ArrowDropDownIcon />
                  </IconButton>
                ),
              }}
              sx={{ cursor: "pointer", "& .MuiInputBase-root": { height: 40 } }}
            />

            <TextField
              label="Search by Project Name"
              name="project_name"
              value={filters.project_name}
              onChange={handleFilterChange}
              size="small"
              fullWidth
              sx={{ "& .MuiInputBase-root": { height: 40 } }}
            />

            <TextField
              label="PI Date"
              value={
                piDateRange.from && piDateRange.to
                  ? `${formatDateDisplay(
                      piDateRange.from
                    )} to ${formatDateDisplay(piDateRange.to)}`
                  : ""
              }
              onClick={(e) => {
                setPiDateMenuAnchor(e.currentTarget);
                setTempPiDateRange(piDateRange);
              }}
              size="small"
              fullWidth
              InputProps={{
                readOnly: true,
                endAdornment: (
                  <IconButton size="small" edge="end">
                    <ArrowDropDownIcon />
                  </IconButton>
                ),
              }}
              InputLabelProps={{ shrink: true }}
              sx={{ cursor: "pointer", "& .MuiInputBase-root": { height: 40 } }}
            />
          </Box>

          <Box
            sx={{ display: "flex", gap: 1, justifyContent: "space-between" }}
          >
            <Button
              variant="contained"
              color="primary"
              size="small"
              onClick={handleReset}
              fullWidth
              sx={{ height: 40, fontSize: "0.75rem" }}
            >
              Reset
            </Button>

            <Button
              variant="contained"
              color="primary"
              onClick={() => navigate("/dashboard/performaInvoice")}
              startIcon={<AddIcon fontSize="small" />}
              fullWidth
              sx={{ height: 40, fontSize: "0.75rem" }}
            >
              Add PI
            </Button>
          </Box>
        </Box>

        {/* Date Range Menu */}
        <Menu
          anchorEl={dateMenuAnchor}
          open={Boolean(dateMenuAnchor)}
          onClose={() => {
            setDateMenuAnchor(null);
            setShowCustomDateInputs(false);
            setTempCustomDateRange({ from: "", to: "" });
          }}
          PaperProps={{
            sx: {
              width: 350,
              maxHeight: 500,
              "& .MuiTypography-root": { fontSize: "0.7rem" },
            },
          }}
        >
          {[
            { key: "today", label: "Today" },
            { key: "yesterday", label: "Yesterday" },
            { key: "this_week", label: "This Week" },
            { key: "previous_week", label: "Previous Week" },
            { key: "this_month", label: "This Month" },
            { key: "current_year", label: "Current Year" },
            { key: "financial_year", label: "Financial Year" },
          ].map((range) => (
            <MenuItem
              key={range.key}
              onClick={() => {
                setFilters((prev) => ({ ...prev, date_range: range.key }));
                setCustomDateRange({ from: "", to: "" });
                setDateMenuAnchor(null);
                setShowCustomDateInputs(false);
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: "100%",
                }}
              >
                <Typography variant="body2">{range.label}</Typography>
                <Typography
                  variant="caption"
                  color="text.secondary"
                  sx={{ fontSize: "0.65rem" }}
                >
                  {getDateRangeDisplay(range.key)}
                </Typography>
              </Box>
            </MenuItem>
          ))}

          <Divider />

          <MenuItem
            onClick={() => setShowCustomDateInputs(!showCustomDateInputs)}
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              bgcolor: showCustomDateInputs
                ? isDark
                  ? theme.palette.grey[800]
                  : "#e3f2fd"
                : "inherit",
            }}
          >
            <Typography
              variant="body2"
              sx={{ fontWeight: showCustomDateInputs ? 600 : 400 }}
            >
              Custom Date Range
            </Typography>
            {showCustomDateInputs ? <ExpandLess /> : <ExpandMore />}
          </MenuItem>

          <Collapse in={showCustomDateInputs} timeout="auto" unmountOnExit>
            <Box
              sx={{
                px: 2,
                py: 2,
                bgcolor: isDark ? theme.palette.grey[900] : "#f5f5f5",
                borderTop: `1px solid ${theme.palette.divider}`,
              }}
              onClick={(e) => e.stopPropagation()}
            >
              <Typography
                variant="caption"
                color="text.secondary"
                sx={{ mb: 1, display: "block" }}
              >
                Select Date Range
              </Typography>

              <Box sx={{ display: "flex", gap: 1, mb: 2 }}>
                <TextField
                  label="From Date"
                  type="date"
                  size="small"
                  value={tempCustomDateRange.from}
                  onChange={(e) =>
                    setTempCustomDateRange((prev) => ({
                      ...prev,
                      from: e.target.value,
                    }))
                  }
                  InputLabelProps={{ shrink: true }}
                  inputProps={{
                    max:
                      tempCustomDateRange.to ||
                      new Date().toISOString().split("T")[0],
                  }}
                  sx={{
                    flex: 1,
                    "& .MuiInputBase-root": { height: 40, fontSize: "0.75rem" },
                    "& .MuiInputLabel-root": { fontSize: "0.75rem" },
                  }}
                />

                <TextField
                  label="To Date"
                  type="date"
                  size="small"
                  value={tempCustomDateRange.to}
                  onChange={(e) =>
                    setTempCustomDateRange((prev) => ({
                      ...prev,
                      to: e.target.value,
                    }))
                  }
                  InputLabelProps={{ shrink: true }}
                  inputProps={{
                    min: tempCustomDateRange.from || undefined,
                    max: new Date().toISOString().split("T")[0],
                  }}
                  sx={{
                    flex: 1,
                    "& .MuiInputBase-root": { height: 40, fontSize: "0.75rem" },
                    "& .MuiInputLabel-root": { fontSize: "0.75rem" },
                  }}
                />
              </Box>

              {tempCustomDateRange.from && tempCustomDateRange.to && (
                <Typography
                  variant="caption"
                  sx={{
                    display: "block",
                    mb: 1.5,
                    p: 1,
                    bgcolor: isDark ? theme.palette.grey[800] : "#e8f5e9",
                    borderRadius: 1,
                    textAlign: "center",
                    color: theme.palette.success.main,
                    fontWeight: 500,
                  }}
                >
                  📅 {formatDateDisplay(tempCustomDateRange.from)} to{" "}
                  {formatDateDisplay(tempCustomDateRange.to)}
                </Typography>
              )}

              <Box sx={{ display: "flex", gap: 1, justifyContent: "flex-end" }}>
                <Button
                  variant="outlined"
                  size="small"
                  onClick={handleCancelCustomDateRange}
                  sx={{
                    fontSize: "0.7rem",
                    textTransform: "none",
                    borderRadius: 1,
                  }}
                >
                  Cancel
                </Button>
                <Button
                  variant="contained"
                  size="small"
                  onClick={handleApplyCustomDateRange}
                  disabled={
                    !tempCustomDateRange.from || !tempCustomDateRange.to
                  }
                  sx={{
                    fontSize: "0.7rem",
                    textTransform: "none",
                    borderRadius: 1,
                  }}
                >
                  Apply
                </Button>
              </Box>
            </Box>
          </Collapse>
        </Menu>
      </Box>

      <Box sx={{ position: "relative", flex: 1, minHeight: "400px" }}>
        {/* Filter Loading Overlay */}
        {filterLoading && (
          <Box
            sx={{
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: isDark
                ? "rgba(0,0,0,0.8)"
                : "rgba(255,255,255,0.9)",
              zIndex: 1000,
              borderRadius: 1,
            }}
          >
            <CircularProgress size={50} thickness={4} color="primary" />
            <Typography sx={{ mt: 2, color: theme.palette.text.primary, fontWeight: 500 }}>
              {filters.date_range === "financial_year"
                ? "Loading Financial Year Data..."
                : filters.date_range === "current_year"
                ? "Loading Current Year Data..."
                : filters.date_range === "this_month"
                ? "Loading This Month Data..."
                : filters.date_range === "this_week"
                ? "Loading This Week Data..."
                : filters.date_range === "previous_week"
                ? "Loading Previous Week Data..."
                : filters.date_range === "custom"
                ? "Loading Custom Date Range..."
                : filters.po_date_from && filters.po_date_to
                ? "Loading PO Date Range..."
                : "Loading Data..."}
            </Typography>
            <Typography sx={{ mt: 0.5, color: theme.palette.text.secondary, fontSize: "0.8rem" }}>
              Please wait, this may take a moment
            </Typography>
          </Box>
        )}

        <InfiniteScroll
          dataLength={proformas.length}
          next={fetchMoreData}
          hasMore={hasMore}
          height="86vh"
          loader={
            <Typography textAlign="center" p={2} color={theme.palette.text.secondary}>
              Loading...
            </Typography>
          }
          endMessage={
            <Typography textAlign="center" p={2} color={theme.palette.text.secondary}>
              No more records!
            </Typography>
          }
        >
          {isMobile ? (
            <Box sx={{ bgcolor: theme.palette.background.default }}>
              {Array.isArray(proformas) && proformas.length > 0 ? (
                proformas.map((invoice, index) => (
                  <MobileProformaCard
                    key={invoice.invoice_number}
                    invoice={invoice}
                    index={index}
                  />
                ))
              ) : (
                <Typography textAlign="center" p={4} color={theme.palette.text.secondary}>
                  No proforma invoices found
                </Typography>
              )}
            </Box>
          ) : (
            <TableContainer
              component={Paper}
              sx={{
                overflowX: "auto",
                bgcolor: theme.palette.background.default,
              }}
            >
              <Table
                stickyHeader
                size="small"
                sx={{
                  minWidth: "max-content",
                  "& td, & th": {
                    borderBottom: `1px solid ${theme.palette.divider}`,
                    whiteSpace: "nowrap",
                  },
                }}
              >
                <TableHead
                  sx={{
                    "& th": {
                      fontWeight: "bold",
                      color: theme.palette.text.primary,
                      backgroundColor: isDark
                        ? theme.palette.grey[900]
                        : "#f5f5f5",
                    },
                  }}
                >
                  <TableRow
                    sx={{
                      backgroundColor: isDark
                        ? theme.palette.grey[900]
                        : "#f5f5f5",
                      "& th": {
                        fontWeight: "bold",
                        color: theme.palette.text.primary,
                        borderBottom: `1px solid ${theme.palette.divider}`,
                        whiteSpace: "nowrap",
                      },
                    }}
                  >
                    <TableCell align="center">S.No.</TableCell>
                    <TableCell
                      sx={{
                        position: "sticky",
                        left: 0,
                        background: isDark ? theme.palette.grey[900] : "#fff",
                        zIndex: 3,
                      }}
                      align="center"
                    >
                      PI No.
                    </TableCell>
                    <TableCell align="center">PI Date</TableCell>
                    <TableCell align="center">Status</TableCell>
                    <TableCell align="center">Debtor</TableCell>
                    <TableCell align="center">PI Amt</TableCell>
                    <TableCell align="center">Project</TableCell>
                    <TableCell align="center">Created By</TableCell>
                    <TableCell align="center">Date</TableCell>
                    <TableCell
                      align="center"
                      sx={{
                        position: "sticky",
                        right: 0,
                        backgroundColor: isDark ? theme.palette.grey[900] : "#fff",
                        zIndex: 3,
                      }}
                    >
                      Action
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {Array.isArray(proformas) && proformas.length > 0 ? (
                    proformas.map((invoice, idx) => (
                      <TableRow
                        key={invoice.invoice_number}
                        hover
                        sx={{
                          backgroundColor:
                            idx % 2 === 0
                              ? isDark
                                ? theme.palette.grey[900]
                                : "#fafafa"
                              : theme.palette.background.paper,
                          "&:hover": {
                            backgroundColor: isDark
                              ? theme.palette.grey[800]
                              : "#e3f2fd !important",
                          },
                          "& td": {
                            paddingTop: "2px !important",
                            paddingBottom: "2px !important",
                            fontSize: { xs: "0.75rem", sm: "0.8125rem" },
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            color: theme.palette.text.primary,
                          },
                        }}
                      >
                        <TableCell align="center">{idx + 1}</TableCell>

                        <TableCell
                          sx={{
                            position: "sticky",
                            left: 0,
                            background: isDark
                              ? theme.palette.grey[900]
                              : "#f9f9f9",
                            zIndex: 1,
                          }}
                          align="center"
                        >
                          {invoice.pi_no || "N/A"}
                        </TableCell>
                        <TableCell align="center">
                          {invoice.pi_date
                            ? new Date(
                                invoice.pi_date + "T00:00:00"
                              ).toLocaleDateString("en-GB")
                            : "N/A"}
                        </TableCell>
                        <TableCell align="center">
                          <Chip
                            label={
                              invoice.status === "Approved"
                                ? "Approved"
                                : invoice.status === "Rejected"
                                ? "Rejected"
                                : "Pending"
                            }
                            color={
                              invoice.status === "Approved"
                                ? "success"
                                : invoice.status === "Rejected"
                                ? "error"
                                : "warning"
                            }
                            variant="outlined"
                            size="small"
                          />
                        </TableCell>
                        <TableCell align="center">
                          <Tooltip
                            title={
                              invoice.project?.party_details?.company_name || "-"
                            }
                            arrow
                          >
                            <span>
                              {truncateText(
                                invoice.project?.party_details?.company_name ||
                                  "-",
                                20
                              )}
                            </span>
                          </Tooltip>
                        </TableCell>
                        <TableCell align="center">
                          {Number(invoice.advance_received || 0).toLocaleString(
                            "en-IN",
                            {
                              minimumFractionDigits: 1,
                              maximumFractionDigits: 1,
                            }
                          )}
                        </TableCell>
                        <TableCell align="center">
                          <Tooltip
                            title={invoice.project?.project_name || "-"}
                            arrow
                          >
                            <span>
                              {truncateText(
                                invoice.project?.project_name || "-",
                                20
                              )}
                            </span>
                          </Tooltip>
                        </TableCell>
                        <TableCell align="center">
                          {invoice.created_by_po || "-"}
                        </TableCell>
                        <TableCell align="center">
                          {formatOnlyDate(invoice.created_at)}
                        </TableCell>
                        <TableCell
                          sx={{
                            position: "sticky",
                            right: 0,
                            backgroundColor: isDark
                              ? theme.palette.grey[900]
                              : "#f9f9f9",
                            zIndex: 1,
                          }}
                          align="center"
                        >
                          <IconButton
                            sx={{ padding: 0, paddingLeft: 1, paddingRight: 1 }}
                            size="small"
                            onClick={() =>
                              navigate(
                                `/dashboard/performaInvoice/${invoice.invoice_number}`,
                                {
                                  state: { invoice },
                                }
                              )
                            }
                            color="primary"
                          >
                            <Edit fontSize="small" />
                          </IconButton>
                          <IconButton
                            sx={{ padding: 0, paddingLeft: 1, paddingRight: 1 }}
                            size="small"
                            color="error"
                            onClick={(e) => {
                              setAnchorEl(e.currentTarget);
                              setInvoiceToDelete(invoice.invoice_number);
                            }}
                          >
                            <DeleteIcon fontSize="small" />
                          </IconButton>
                          <IconButton
                            sx={{ padding: 0, paddingLeft: 1, paddingRight: 1 }}
                            size="small"
                            onClick={() => printPerforma(invoice)}
                          >
                            <Print fontSize="small" />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell colSpan={15} align="center">
                        <Typography p={1} color={theme.palette.text.secondary}>
                          No proforma invoices found
                        </Typography>
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          )}
        </InfiniteScroll>
      </Box>

      {/* Delete Confirmation Popover */}
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
        PaperProps={{
          sx: {
            bgcolor: theme.palette.background.paper,
          },
        }}
      >
        <Box sx={{ p: 2, width: 220 }}>
          <Typography sx={{ mb: 1, color: theme.palette.text.primary }}>
            Are you sure you want to delete?
          </Typography>

          <Box
            sx={{ display: "flex", justifyContent: "space-between", gap: 1 }}
          >
            <Button size="small" onClick={() => setAnchorEl(null)}>
              Cancel
            </Button>
            <Button
              size="small"
              color="error"
              onClick={() => {
                handleDelete(invoiceToDelete);
                setAnchorEl(null);
              }}
            >
              Delete
            </Button>
          </Box>
        </Box>
      </Popover>

      {/* Approval Dialog - dark mode ready */}
      <Dialog
        open={approvalDialogOpen}
        onClose={() => {
          setApprovalDialogOpen(false);
          setRemarkInput("");
          setPIToApprove(null);
        }}
        maxWidth="lg"
        fullWidth
        fullScreen={isMobile}
        scroll="paper"
        PaperProps={{
          sx: {
            minHeight: isMobile ? "100vh" : "80vh",
            maxHeight: isMobile ? "100vh" : "90vh",
            m: isMobile ? 0 : 2,
            borderRadius: isMobile ? 0 : 2,
            bgcolor: theme.palette.background.paper,
          },
        }}
      >
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            pb: 1,
            px: isMobile ? 1.5 : 3,
            pt: isMobile ? 1.5 : 2,
            borderBottom: `1px solid ${theme.palette.divider}`,
            position: "sticky",
            top: 0,
            bgcolor: theme.palette.background.paper,
            zIndex: 10,
          }}
        >
          <Typography
            variant={isMobile ? "subtitle1" : "h6"}
            sx={{
              fontSize: isMobile ? "0.95rem" : "1.25rem",
              fontWeight: 600,
              color: theme.palette.text.primary,
            }}
          >
            Review Proforma Invoice
          </Typography>
          <IconButton
            onClick={() => {
              setApprovalDialogOpen(false);
              setRemarkInput("");
              setPIToApprove(null);
            }}
            size={isMobile ? "small" : "medium"}
            sx={{
              bgcolor: isDark ? theme.palette.grey[800] : "#f5f5f5",
              "&:hover": { bgcolor: isDark ? theme.palette.grey[700] : "#e0e0e0" },
            }}
          >
            <CloseIcon sx={{ fontSize: isMobile ? "1.2rem" : "1.5rem" }} />
          </IconButton>
        </DialogTitle>

        <DialogContent
          dividers
          sx={{
            p: isMobile ? 0.5 : 2,
            bgcolor: isDark ? theme.palette.grey[900] : "#f9f9f9",
            overflowX: "hidden",
          }}
        >
          {piToApprove && (
            <Box
              sx={{
                width: "100%",
                border: `1px solid ${theme.palette.divider}`,
                bgcolor: theme.palette.background.paper,
                mx: "auto",
              }}
            >
              {/* Header - Red Title */}
              <Box
                sx={{
                  color: theme.palette.error.main,
                  textAlign: "center",
                  fontWeight: "bold",
                  fontSize: isMobile ? "12px" : "18px",
                  p: isMobile ? 0.5 : 1.5,
                  border: `1px solid ${theme.palette.divider}`,
                  borderBottom: "none",
                }}
              >
                PROFORMA INVOICE
              </Box>

              {/* MOBILE OPTIMIZED LAYOUT */}
              {isMobile ? (
                <Box sx={{ border: `1px solid ${theme.palette.divider}`, borderTop: "none" }}>
                  {/* Compact Header Section - Mobile */}
                  <Box
                    sx={{
                      borderBottom: `1px solid ${theme.palette.divider}`,
                      p: 0.8,
                      bgcolor: isDark ? theme.palette.grey[900] : "#f9f9f9",
                    }}
                  >
                    <Grid container spacing={0.5}>
                      <Grid item xs={6}>
                        <Typography sx={{ fontSize: "0.5rem", color: theme.palette.text.secondary }}>
                          PI No:
                        </Typography>
                        <Typography
                          sx={{ fontSize: "0.6rem", fontWeight: 600, mb: 0.3, color: theme.palette.text.primary }}
                        >
                          {piToApprove.pi_no || "N/A"}
                        </Typography>

                        <Typography sx={{ fontSize: "0.5rem", color: theme.palette.text.secondary }}>
                          PI Date:
                        </Typography>
                        <Typography
                          sx={{ fontSize: "0.6rem", fontWeight: 600, mb: 0.3, color: theme.palette.text.primary }}
                        >
                          {formatOnlyDate(piToApprove.pi_date)}
                        </Typography>

                        <Typography sx={{ fontSize: "0.5rem", color: theme.palette.text.secondary }}>
                          S.O. No:
                        </Typography>
                        <Typography
                          sx={{ fontSize: "0.6rem", fontWeight: 600, color: theme.palette.text.primary }}
                        >
                          {piToApprove.project?.so_no || "N/A"}
                        </Typography>
                      </Grid>
                      <Grid item xs={6}>
                        <Typography sx={{ fontSize: "0.5rem", color: theme.palette.text.secondary }}>
                          P.O. No:
                        </Typography>
                        <Typography
                          sx={{ fontSize: "0.6rem", fontWeight: 600, mb: 0.3, color: theme.palette.text.primary }}
                        >
                          {piToApprove.project?.po_number || "-"}
                        </Typography>

                        <Typography sx={{ fontSize: "0.5rem", color: theme.palette.text.secondary }}>
                          P.O. Date:
                        </Typography>
                        <Typography
                          sx={{ fontSize: "0.6rem", fontWeight: 600, mb: 0.3, color: theme.palette.text.primary }}
                        >
                          {formatOnlyDate(piToApprove.project?.order_date)}
                        </Typography>

                        <Typography sx={{ fontSize: "0.5rem", color: theme.palette.text.secondary }}>
                          Created:
                        </Typography>
                        <Typography
                          sx={{ fontSize: "0.6rem", fontWeight: 600, color: theme.palette.text.primary }}
                        >
                          {formatOnlyDate(piToApprove.created_at)}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Box>

                  {/* Seller */}
                  <Box sx={{ borderBottom: `1px solid ${theme.palette.divider}`, p: 0.8 }}>
                    <Box sx={{ display: "flex", gap: 0.8, alignItems: "center" }}>
                      <Box sx={{ width: "70px", height: "70px", flexShrink: 0 }}>
                        <img
                          src={"/logoblack.png"}
                          alt="Logo"
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "contain",
                          }}
                        />
                      </Box>
                      <Box sx={{ flex: 1 }}>
                        <Typography
                          sx={{
                            fontWeight: "bold",
                            fontSize: "0.6rem",
                            lineHeight: 1.2,
                            color: theme.palette.text.primary,
                          }}
                        >
                          CRANOIST MHE PVT. LTD.
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: "0.5rem",
                            lineHeight: 1.2,
                            color: theme.palette.text.secondary,
                          }}
                        >
                          Plot No.37, Phase-II, Siltara, Raipur (C.G.), 493111
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: "0.5rem",
                            lineHeight: 1.2,
                            color: theme.palette.text.secondary,
                          }}
                        >
                          📞 8224086999, 9825586999
                        </Typography>
                        <Typography
                          sx={{
                            fontSize: "0.5rem",
                            color: "primary.main",
                            lineHeight: 1.2,
                          }}
                        >
                          ✉ info@cranoistmhe.com
                        </Typography>
                      </Box>
                    </Box>
                  </Box>

                  {/* Buyer & Billing */}
                  <Box
                    sx={{
                      display: "grid",
                      gridTemplateColumns: "1fr 1fr",
                      borderBottom: `1px solid ${theme.palette.divider}`,
                    }}
                  >
                    <Box sx={{ p: 0.8, borderRight: `1px solid ${theme.palette.divider}` }}>
                      <Typography
                        sx={{
                          fontWeight: "bold",
                          fontSize: "0.55rem",
                          mb: 0.3,
                          color: theme.palette.primary.main,
                        }}
                      >
                        BUYER
                      </Typography>
                      <Typography
                        sx={{
                          fontWeight: "bold",
                          fontSize: "0.55rem",
                          mb: 0.2,
                          color: theme.palette.text.primary,
                        }}
                      >
                        {piToApprove.project?.party_details?.company_name ||
                          "N/A"}
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "0.5rem",
                          lineHeight: 1.2,
                          color: theme.palette.text.secondary,
                        }}
                      >
                        GST: {piToApprove.project?.party_details?.gst || "N/A"}
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "0.5rem",
                          lineHeight: 1.2,
                          color: theme.palette.text.secondary,
                        }}
                      >
                        State:{" "}
                        {piToApprove.project?.party_details?.state || "22"}
                      </Typography>
                    </Box>
                    <Box sx={{ p: 0.8 }}>
                      <Typography
                        sx={{
                          fontWeight: "bold",
                          fontSize: "0.55rem",
                          mb: 0.3,
                          color: theme.palette.primary.main,
                        }}
                      >
                        BILLING ADDR
                      </Typography>
                      <Typography
                        sx={{ fontSize: "0.5rem", lineHeight: 1.2, mb: 0.2, color: theme.palette.text.primary }}
                      >
                        {piToApprove.project?.party_details?.address?.substring(
                          0,
                          60
                        ) || "Same as Buyer"}
                        {piToApprove.project?.party_details?.address?.length >
                          60 && "..."}
                      </Typography>
                    </Box>
                  </Box>

                  {/* Tax & Payment */}
                  <Box
                    sx={{
                      display: "grid",
                      gridTemplateColumns: "1fr 1fr",
                      borderBottom: `1px solid ${theme.palette.divider}`,
                    }}
                  >
                    <Box sx={{ p: 0.8, borderRight: `1px solid ${theme.palette.divider}` }}>
                      <Typography
                        sx={{
                          fontWeight: "bold",
                          fontSize: "0.55rem",
                          mb: 0.3,
                          color: theme.palette.primary.main,
                        }}
                      >
                        TAX TERMS
                      </Typography>
                      {Array.isArray(piToApprove.tax_terms) &&
                        piToApprove.tax_terms.length > 0 ? (
                        piToApprove.tax_terms
                          .slice(0, 2)
                          .map((taxTerm, index) => (
                            <Typography
                              key={index}
                              sx={{
                                fontSize: "0.5rem",
                                lineHeight: 1.2,
                                mb: 0.1,
                                color: theme.palette.text.primary,
                              }}
                            >
                              {index + 1}){" "}
                              {taxTerm.term?.substring(0, 35) || "N/A"}
                              {taxTerm.term?.length > 35 && "..."}
                            </Typography>
                          ))
                      ) : (
                        <>
                          <Typography
                            sx={{
                              fontSize: "0.5rem",
                              lineHeight: 1.2,
                              mb: 0.1,
                              color: theme.palette.text.primary,
                            }}
                          >
                            1) GST {piToApprove.gst_percent || "0"}% Extra
                          </Typography>
                          <Typography
                            sx={{ fontSize: "0.5rem", lineHeight: 1.2, color: theme.palette.text.primary }}
                          >
                            2) Freight F.O.R. Site
                          </Typography>
                        </>
                      )}
                    </Box>
                    <Box sx={{ p: 0.8 }}>
                      <Typography
                        sx={{
                          fontWeight: "bold",
                          fontSize: "0.55rem",
                          mb: 0.3,
                          color: theme.palette.primary.main,
                        }}
                      >
                        PAYMENT TERMS
                      </Typography>
                      {Array.isArray(piToApprove.payment_terms) &&
                        piToApprove.payment_terms.length > 0 ? (
                        piToApprove.payment_terms
                          .slice(0, 2)
                          .map((paymentTerm, index) => (
                            <Typography
                              key={index}
                              sx={{
                                fontSize: "0.5rem",
                                lineHeight: 1.2,
                                mb: 0.1,
                                color: theme.palette.text.primary,
                              }}
                            >
                              {index + 1}){" "}
                              {paymentTerm.term?.substring(0, 35) || "N/A"}
                              {paymentTerm.term?.length > 35 && "..."}
                            </Typography>
                          ))
                      ) : (
                        <Typography
                          sx={{ fontSize: "0.5rem", lineHeight: 1.2, color: theme.palette.text.primary }}
                        >
                          1) 50% adv, bal on delivery
                        </Typography>
                      )}
                    </Box>
                  </Box>

                  {/* Items - Card view */}
                  <Box sx={{ borderBottom: `1px solid ${theme.palette.divider}` }}>
                    <Typography
                      sx={{
                        fontWeight: "bold",
                        textAlign: "center",
                        fontSize: "0.65rem",
                        p: 0.8,
                        bgcolor: isDark ? theme.palette.grey[800] : "#f5f5f5",
                        borderBottom: `1px solid ${theme.palette.divider}`,
                        color: theme.palette.text.primary,
                      }}
                    >
                      ITEMS DETAILS
                    </Typography>

                    {Array.isArray(piToApprove.project?.items) &&
                      piToApprove.project.items.length > 0 ? (
                      piToApprove.project.items.map((item, i) => (
                        <Box
                          key={i}
                          sx={{
                            p: 1,
                            borderBottom:
                              i < piToApprove.project.items.length - 1
                                ? `1px solid ${theme.palette.divider}`
                                : "none",
                            bgcolor: i % 2 === 0 ? theme.palette.background.default : theme.palette.background.paper,
                          }}
                        >
                          <Typography
                            sx={{
                              fontWeight: "bold",
                              fontSize: "0.6rem",
                              mb: 0.5,
                              color: theme.palette.primary.main,
                            }}
                          >
                            {i + 1}.{" "}
                            {item.item_name || item.description || "N/A"}
                          </Typography>

                          {item.description &&
                            item.item_name !== item.description && (
                              <Typography
                                sx={{
                                  fontSize: "0.55rem",
                                  color: theme.palette.text.secondary,
                                  mb: 0.5,
                                  fontStyle: "italic",
                                }}
                              >
                                {item.description}
                              </Typography>
                            )}

                          <Box
                            sx={{
                              display: "grid",
                              gridTemplateColumns: "1fr 1fr",
                              gap: 0.5,
                            }}
                          >
                            <Box
                              sx={{
                                display: "flex",
                                justifyContent: "space-between",
                                borderBottom: `1px solid ${theme.palette.divider}`,
                                pb: 0.3,
                              }}
                            >
                              <Typography
                                sx={{ fontSize: "0.55rem", color: theme.palette.text.secondary }}
                              >
                                UOM:
                              </Typography>
                              <Typography
                                sx={{ fontSize: "0.55rem", fontWeight: 500, color: theme.palette.text.primary }}
                              >
                                {item.uom || "Nos"}
                              </Typography>
                            </Box>
                            <Box
                              sx={{
                                display: "flex",
                                justifyContent: "space-between",
                                borderBottom: `1px solid ${theme.palette.divider}`,
                                pb: 0.3,
                              }}
                            >
                              <Typography
                                sx={{ fontSize: "0.55rem", color: theme.palette.text.secondary }}
                              >
                                Qty:
                              </Typography>
                              <Typography
                                sx={{ fontSize: "0.55rem", fontWeight: 500, color: theme.palette.text.primary }}
                              >
                                {Number(
                                  item.pi_qty || item.quantity || 0
                                ).toFixed(2)}
                              </Typography>
                            </Box>
                            <Box
                              sx={{
                                display: "flex",
                                justifyContent: "space-between",
                                borderBottom: `1px solid ${theme.palette.divider}`,
                                pb: 0.3,
                              }}
                            >
                              <Typography
                                sx={{ fontSize: "0.55rem", color: theme.palette.text.secondary }}
                              >
                                Rate:
                              </Typography>
                              <Typography
                                sx={{ fontSize: "0.55rem", fontWeight: 500, color: theme.palette.text.primary }}
                              >
                                ₹
                                {Number(item.rate || 0).toLocaleString(
                                  "en-IN",
                                  {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  }
                                )}
                              </Typography>
                            </Box>
                            <Box
                              sx={{
                                display: "flex",
                                justifyContent: "space-between",
                                pb: 0.3,
                              }}
                            >
                              <Typography
                                sx={{ fontSize: "0.55rem", color: theme.palette.text.secondary }}
                              >
                                Amount:
                              </Typography>
                              <Typography
                                sx={{
                                  fontSize: "0.55rem",
                                  fontWeight: 600,
                                  color: theme.palette.success.main,
                                }}
                              >
                                ₹
                                {Number(item.amount || 0).toLocaleString(
                                  "en-IN",
                                  {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  }
                                )}
                              </Typography>
                            </Box>
                          </Box>
                        </Box>
                      ))
                    ) : (
                      <Box sx={{ p: 1, bgcolor: theme.palette.background.default }}>
                        <Typography
                          sx={{
                            fontWeight: "bold",
                            fontSize: "0.6rem",
                            mb: 0.5,
                            color: theme.palette.text.primary,
                          }}
                        >
                          {piToApprove.remarks ||
                            `Advance for ${piToApprove.project?.project_name || "N/A"
                            }`}
                        </Typography>
                        <Box
                          sx={{
                            display: "grid",
                            gridTemplateColumns: "1fr 1fr",
                            gap: 0.5,
                          }}
                        >
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                          >
                            <Typography
                              sx={{ fontSize: "0.55rem", color: theme.palette.text.secondary }}
                            >
                              UOM:
                            </Typography>
                            <Typography
                              sx={{ fontSize: "0.55rem", fontWeight: 500, color: theme.palette.text.primary }}
                            >
                              LS
                            </Typography>
                          </Box>
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                          >
                            <Typography
                              sx={{ fontSize: "0.55rem", color: theme.palette.text.secondary }}
                            >
                              Qty:
                            </Typography>
                            <Typography
                              sx={{ fontSize: "0.55rem", fontWeight: 500, color: theme.palette.text.primary }}
                            >
                              1
                            </Typography>
                          </Box>
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                          >
                            <Typography
                              sx={{ fontSize: "0.55rem", color: theme.palette.text.secondary }}
                            >
                              Rate:
                            </Typography>
                            <Typography
                              sx={{ fontSize: "0.55rem", fontWeight: 500, color: theme.palette.text.primary }}
                            >
                              ₹
                              {Number(
                                piToApprove.basic_value || 0
                              ).toLocaleString("en-IN", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })}
                            </Typography>
                          </Box>
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                          >
                            <Typography
                              sx={{ fontSize: "0.55rem", color: theme.palette.text.secondary }}
                            >
                              Amount:
                            </Typography>
                            <Typography
                              sx={{
                                fontSize: "0.55rem",
                                fontWeight: 600,
                                color: theme.palette.success.main,
                              }}
                            >
                              ₹
                              {Number(
                                piToApprove.basic_value || 0
                              ).toLocaleString("en-IN", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })}
                            </Typography>
                          </Box>
                        </Box>
                      </Box>
                    )}
                  </Box>

                  {/* Summary */}
                  <Box sx={{ borderBottom: `1px solid ${theme.palette.divider}` }}>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        p: 0.8,
                        bgcolor: isDark ? theme.palette.grey[800] : "#f5f5f5",
                        borderBottom: `1px solid ${theme.palette.divider}`,
                      }}
                    >
                      <Typography
                        sx={{ fontSize: "0.6rem", fontWeight: "bold", color: theme.palette.text.primary }}
                      >
                        BASIC VALUE
                      </Typography>
                      <Typography
                        sx={{ fontSize: "0.6rem", fontWeight: "bold", color: theme.palette.text.primary }}
                      >
                        ₹
                        {Number(piToApprove.basic_value || 0).toLocaleString(
                          "en-IN",
                          {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          }
                        )}
                      </Typography>
                    </Box>

                    {piToApprove.gst_amount > 0 && (
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          p: 0.8,
                          borderBottom: `1px solid ${theme.palette.divider}`,
                        }}
                      >
                        <Typography sx={{ fontSize: "0.6rem", color: theme.palette.text.primary }}>
                          GST @ {piToApprove.gst_percent || 0}%
                        </Typography>
                        <Typography sx={{ fontSize: "0.6rem", color: theme.palette.text.primary }}>
                          ₹
                          {Number(piToApprove.gst_amount || 0).toLocaleString(
                            "en-IN",
                            {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            }
                          )}
                        </Typography>
                      </Box>
                    )}

                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        p: 0.8,
                        bgcolor: isDark ? theme.palette.grey[800] : "#e3f2fd",
                      }}
                    >
                      <Typography
                        sx={{ fontSize: "0.6rem", fontWeight: "bold", color: theme.palette.text.primary }}
                      >
                        PAYABLE AS ADV @ {piToApprove.advance_percent || 0}%
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "0.6rem",
                          fontWeight: "bold",
                          color: theme.palette.success.main,
                        }}
                      >
                        ₹
                        {Number(
                          piToApprove.advance_received || 0
                        ).toLocaleString("en-IN", {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </Typography>
                    </Box>
                  </Box>

                  {/* Amount in Words */}
                  <Box sx={{ p: 0.8, borderBottom: `1px solid ${theme.palette.divider}` }}>
                    <Typography
                      sx={{ fontWeight: "bold", fontSize: "0.6rem", mb: 0.2, color: theme.palette.text.primary }}
                    >
                      In Words:
                    </Typography>
                    <Typography
                      sx={{ fontSize: "0.55rem", fontStyle: "italic", color: theme.palette.text.secondary }}
                    >
                      {piToApprove.amount_in_words || "N/A"}
                    </Typography>
                  </Box>

                  {/* Terms */}
                  <Box sx={{ p: 0.8, borderBottom: `1px solid ${theme.palette.divider}` }}>
                    <Typography
                      sx={{ fontWeight: "bold", fontSize: "0.6rem", mb: 0.3, color: theme.palette.text.primary }}
                    >
                      Terms & Conditions:
                    </Typography>
                    {Array.isArray(piToApprove.project?.terms_and_conditions) &&
                      piToApprove.project.terms_and_conditions.length > 0 ? (
                      piToApprove.project.terms_and_conditions
                        .filter(
                          (tc) =>
                            tc.key === "Jurisdiction" ||
                            tc.key === "Rejection/Claim" ||
                            tc.key === "Remark"
                        )
                        .map((tc, index) => (
                          <Typography
                            key={index}
                            sx={{
                              fontSize: "0.55rem",
                              lineHeight: 1.3,
                              mb: 0.2,
                              color: theme.palette.text.primary,
                            }}
                          >
                            {index + 1}. {tc.key}: {tc.value}
                          </Typography>
                        ))
                    ) : (
                      <>
                        <Typography
                          sx={{ fontSize: "0.55rem", lineHeight: 1.3, mb: 0.2, color: theme.palette.text.primary }}
                        >
                          1. Dispute subject to Raipur Jurisdiction
                        </Typography>
                        <Typography
                          sx={{ fontSize: "0.55rem", lineHeight: 1.3, color: theme.palette.text.primary }}
                        >
                          2. Interest @22% p.a. after 7 days
                        </Typography>
                      </>
                    )}
                  </Box>

                  {/* Bank Details */}
                  <Box sx={{ p: 0.8, borderBottom: `1px solid ${theme.palette.divider}` }}>
                    <Typography
                      sx={{
                        fontWeight: "bold",
                        fontSize: "0.6rem",
                        mb: 0.3,
                        textDecoration: "underline",
                        color: theme.palette.text.primary,
                      }}
                    >
                      Bank Transfer Details:
                    </Typography>
                    {piToApprove.bank_details ? (
                      <>
                        <Typography
                          sx={{ fontSize: "0.55rem", lineHeight: 1.3, color: theme.palette.text.primary }}
                        >
                          <strong>A/C:</strong>{" "}
                          {piToApprove.bank_details.account_number || "N/A"}
                        </Typography>
                        <Typography
                          sx={{ fontSize: "0.55rem", lineHeight: 1.3, color: theme.palette.text.primary }}
                        >
                          <strong>Bank:</strong>{" "}
                          {piToApprove.bank_details.bank_name || "N/A"}
                        </Typography>
                        <Typography
                          sx={{ fontSize: "0.55rem", lineHeight: 1.3, color: theme.palette.text.primary }}
                        >
                          <strong>IFSC:</strong>{" "}
                          {piToApprove.bank_details.ifsc_code || "N/A"}
                        </Typography>
                      </>
                    ) : (
                      <>
                        <Typography
                          sx={{ fontSize: "0.55rem", lineHeight: 1.3, color: theme.palette.text.primary }}
                        >
                          <strong>A/C:</strong> 22222563453
                        </Typography>
                        <Typography
                          sx={{ fontSize: "0.55rem", lineHeight: 1.3, color: theme.palette.text.primary }}
                        >
                          <strong>Bank:</strong> HDFC, Sun and Suns
                        </Typography>
                        <Typography
                          sx={{ fontSize: "0.55rem", lineHeight: 1.3, color: theme.palette.text.primary }}
                        >
                          <strong>IFSC:</strong> AAAA0001ABC
                        </Typography>
                      </>
                    )}
                  </Box>

                  {/* GST & Authorization */}
                  <Box sx={{ display: "grid", gridTemplateColumns: "1fr 1fr" }}>
                    <Box sx={{ p: 0.8, borderRight: `1px solid ${theme.palette.divider}` }}>
                      <Typography
                        sx={{
                          fontWeight: "bold",
                          fontSize: "0.6rem",
                          mb: 0.3,
                          textAlign: "center",
                          color: theme.palette.text.primary,
                        }}
                      >
                        GST INFO
                      </Typography>
                      <Typography sx={{ fontSize: "0.55rem", lineHeight: 1.3, color: theme.palette.text.primary }}>
                        GSTIN: {divisionLocalStorage?.gst_no || "22AAHFK2314C1Z4"}
                      </Typography>
                      <Typography sx={{ fontSize: "0.55rem", lineHeight: 1.3, color: theme.palette.text.primary }}>
                        PAN: {divisionLocalStorage?.pan_no || "AAHFK2314C1"}
                      </Typography>
                    </Box>
                    <Box
                      sx={{
                        p: 0.8,
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <Typography
                        sx={{ fontWeight: "bold", fontSize: "0.6rem", mb: 1, color: theme.palette.text.primary }}
                      >
                        AUTHORIZATION
                      </Typography>
                      <Typography sx={{ fontSize: "0.55rem", color: theme.palette.text.primary }}>
                        For CRANOIST MHE PVT. LTD.
                      </Typography>
                      <Typography sx={{ fontSize: "0.55rem", mt: 1.5, color: theme.palette.text.primary }}>
                        (Signature)
                      </Typography>
                      <Typography sx={{ fontSize: "0.55rem", color: theme.palette.text.primary }}>
                        Auth. Signatory
                      </Typography>
                    </Box>
                  </Box>
                </Box>
              ) : (
                /* DESKTOP LAYOUT */
                <Box>
                  <table style={styles.table}>
                    <tbody>
                      <tr>
                        <td style={{ ...styles.cell, width: "50%" }}>
                          <div style={{ ...styles.bold, textAlign: "center", color: theme.palette.text.primary }}>
                            SELLER
                          </div>
                          <Box sx={{ mt: 1 }}>
                            <div
                              style={{
                                float: "left",
                                width: "100px",
                                height: "100px",
                              }}
                            >
                              <img
                                src={"/logoblack.png"}
                                alt="Company Logo"
                                style={{
                                  width: "100%",
                                  height: "100%",
                                  objectFit: "contain",
                                }}
                              />
                            </div>
                            <div
                              style={{
                                fontWeight: "bold",
                                textAlign: "center",
                                color: theme.palette.text.primary,
                              }}
                            >
                              CRANOIST MHE PVT. LTD.
                            </div>
                            <div style={{ textAlign: "center", color: theme.palette.text.primary }}>
                              Works: Plot No.37, Phase-II, Siltara Ind. Area,
                            </div>
                            <div style={{ textAlign: "center", color: theme.palette.text.primary }}>
                              Rashmada Bhilai RAipur (c.g)
                            </div>
                            <div style={{ textAlign: "center", color: theme.palette.text.primary }}>
                              Contact: 8224086999, 9825586999
                            </div>
                            <div style={{ color: theme.palette.primary.main, textAlign: "center" }}>
                              E-mail: info@cranoistmhe.com
                            </div>
                          </Box>
                        </td>
                        <td
                          style={{
                            ...styles.cell,
                            width: "25%",
                            textAlign: "center",
                          }}
                        >
                          <div style={{ ...styles.bold, color: theme.palette.text.primary }}>No & Date</div>
                          <div style={{ marginTop: "10px", color: theme.palette.text.primary }}>
                            PI No: {piToApprove.pi_no || "N/A"}
                          </div>
                          <div style={{ marginTop: "5px", color: theme.palette.text.primary }}>
                            PI Date: {formatOnlyDate(piToApprove.pi_date)}
                          </div>
                          <div style={{ marginTop: "5px", color: theme.palette.text.primary }}>
                            Created Date:{" "}
                            {formatOnlyDate(piToApprove.created_at)}
                          </div>
                          <div style={{ marginTop: "5px", color: theme.palette.text.primary }}>
                            S.O. No: {piToApprove.project?.so_no || "N/A"}
                          </div>
                        </td>
                        <td
                          style={{
                            ...styles.cell,
                            width: "25%",
                            textAlign: "center",
                          }}
                        >
                          <div style={{ ...styles.bold, color: theme.palette.text.primary }}>Buyer's Order No & Date</div>
                          <div style={{ marginTop: "10px", color: theme.palette.text.primary }}>
                            P.O. No: {piToApprove.project?.po_number || "-"}
                          </div>
                          <div style={{ marginTop: "10px", color: theme.palette.text.primary }}>
                            P.O. Date:{" "}
                            {formatOnlyDate(piToApprove.project?.order_date)}
                          </div>
                        </td>
                      </tr>

                      <tr>
                        <td
                          style={{ ...styles.headerCell, textAlign: "center" }}
                        >
                          BUYER
                        </td>
                        <td
                          style={{ ...styles.headerCell, textAlign: "center" }}
                          colSpan={2}
                        >
                          BILLING ADDRESS
                        </td>
                      </tr>

                      <tr>
                        <td style={styles.cell}>
                          <div style={{ ...styles.bold, color: theme.palette.text.primary }}>
                            {piToApprove.project?.party_details?.company_name ||
                              "N/A"}
                          </div>
                          <div style={{ color: theme.palette.text.primary }}>
                            GSTIN:{" "}
                            {piToApprove.project?.party_details?.gst || "N/A"}
                          </div>
                          <div style={{ color: theme.palette.text.primary }}>
                            STATE CODE:{" "}
                            {piToApprove.project?.party_details?.state || "22"}
                          </div>
                          <div style={{ color: theme.palette.text.primary }}>
                            Address:{" "}
                            {piToApprove.project?.party_details?.address ||
                              "N/A"}
                          </div>
                        </td>
                        <td style={styles.cell} colSpan={2}>
                          <div style={{ ...styles.bold, color: theme.palette.text.primary }}>
                            {piToApprove.project?.party_details?.company_name ||
                              "N/A"}
                          </div>
                          <div style={{ color: theme.palette.text.primary }}>
                            {piToApprove.shipping_address ||
                              piToApprove.project?.party_details?.address ||
                              "Same as Buyer"}
                          </div>
                          <div style={{ color: theme.palette.text.primary }}>
                            GSTIN:{" "}
                            {piToApprove.project?.party_details?.gst || "N/A"}
                          </div>
                          <div style={{ color: theme.palette.text.primary }}>
                            STATE CODE:{" "}
                            {piToApprove.project?.party_details?.state || "22"}
                          </div>
                        </td>
                      </tr>

                      <tr>
                        <td style={styles.headerCell}>TAX TERMS</td>
                        <td style={styles.headerCell} colSpan={2}>
                          PAYMENT TERMS
                        </td>
                      </tr>

                      <tr>
                        <td style={styles.cell}>
                          {Array.isArray(piToApprove.tax_terms) &&
                            piToApprove.tax_terms.length > 0 ? (
                            piToApprove.tax_terms.map((taxTerm, index) => (
                              <div key={index} style={{ color: theme.palette.text.primary }}>
                                {index + 1}) {taxTerm.term || "N/A"}
                              </div>
                            ))
                          ) : (
                            <>
                              <div style={{ color: theme.palette.text.primary }}>
                                1) GST {piToApprove.gst_percent || "0"}% Extra
                                as Applicable
                              </div>
                              <div style={{ color: theme.palette.text.primary }}>
                                2) Freight F.O.R. HFAL Site
                              </div>
                            </>
                          )}
                        </td>
                        <td style={styles.cell} colSpan={2}>
                          {Array.isArray(piToApprove.payment_terms) &&
                            piToApprove.payment_terms.length > 0 ? (
                            piToApprove.payment_terms.map(
                              (paymentTerm, index) => (
                                <div key={index} style={{ color: theme.palette.text.primary }}>
                                  {index + 1}) {paymentTerm.term || "N/A"}
                                </div>
                              )
                            )
                          ) : (
                            <div style={{ color: theme.palette.text.primary }}>
                              1) 50% advance, balance on delivery
                            </div>
                          )}
                        </td>
                      </tr>
                    </tbody>
                  </table>

                  {/* ITEMS TABLE */}
                  <table style={{ ...styles.table, marginTop: "-1px" }}>
                    <thead>
                      <tr>
                        <th style={{ ...styles.headerCell, width: "5%" }}>NO</th>
                        <th style={{ ...styles.headerCell, width: "40%" }}>
                          DESCRIPTION
                        </th>
                        <th style={{ ...styles.headerCell, width: "10%" }}>
                          UOM
                        </th>
                        <th style={{ ...styles.headerCell, width: "10%" }}>
                          QTY.
                        </th>
                        <th style={{ ...styles.headerCell, width: "15%" }}>
                          RATE (Rs.)
                        </th>
                        <th style={{ ...styles.headerCell, width: "20%" }}>
                          AMOUNT (Rs.)
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {Array.isArray(piToApprove.project?.items) &&
                        piToApprove.project.items.length > 0 ? (
                        piToApprove.project.items.map((item, i) => (
                          <tr key={i}>
                            <td style={{ ...styles.cell, textAlign: "center" }}>
                              {i + 1}
                            </td>
                            <td style={styles.cell}>
                              {item.description || item.item_name || "N/A"}
                            </td>
                            <td style={{ ...styles.cell, textAlign: "center" }}>
                              {item.uom || "Nos"}
                            </td>
                            <td style={{ ...styles.cell, textAlign: "right" }}>
                              {Number(
                                item.pi_qty || item.quantity || 0
                              ).toFixed(2)}
                            </td>
                            <td style={{ ...styles.cell, textAlign: "right" }}>
                              {Number(item.rate || 0).toLocaleString("en-IN", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })}
                            </td>
                            <td style={{ ...styles.cell, textAlign: "right" }}>
                              {Number(item.amount || 0).toLocaleString(
                                "en-IN",
                                {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                }
                              )}
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td style={{ ...styles.cell, textAlign: "center" }}>
                            1
                          </td>
                          <td style={styles.cell}>
                            {piToApprove.remarks ||
                              `Advance for ${piToApprove.project?.project_name || "N/A"
                              }`}
                          </td>
                          <td style={{ ...styles.cell, textAlign: "center" }}>
                            LS
                          </td>
                          <td style={{ ...styles.cell, textAlign: "right" }}>
                            1
                          </td>
                          <td style={{ ...styles.cell, textAlign: "right" }}>
                            {Number(
                              piToApprove.basic_value || 0
                            ).toLocaleString("en-IN", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                          </td>
                          <td style={{ ...styles.cell, textAlign: "right" }}>
                            {Number(
                              piToApprove.basic_value || 0
                            ).toLocaleString("en-IN", {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            })}
                          </td>
                        </tr>
                      )}

                      <tr>
                        <td
                          style={{
                            ...styles.cell,
                            textAlign: "right",
                            fontWeight: "bold",
                          }}
                          colSpan={5}
                        >
                          BASIC VALUE
                        </td>
                        <td
                          style={{
                            ...styles.cell,
                            textAlign: "right",
                            fontWeight: "bold",
                          }}
                        >
                          {Number(piToApprove.basic_value || 0).toLocaleString(
                            "en-IN",
                            {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2,
                            }
                          )}
                        </td>
                      </tr>

                      {piToApprove.gst_amount > 0 && (
                        <tr>
                          <td
                            style={{ ...styles.cell, textAlign: "right" }}
                            colSpan={5}
                          >
                            GST @ {piToApprove.gst_percent || 0}%
                          </td>
                          <td style={{ ...styles.cell, textAlign: "right" }}>
                            {Number(piToApprove.gst_amount || 0).toLocaleString(
                              "en-IN",
                              {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              }
                            )}
                          </td>
                        </tr>
                      )}

                      <tr>
                        <td
                          style={{ ...styles.cell, fontWeight: "bold" }}
                          colSpan={5}
                        >
                          {piToApprove.installment_summary ||
                            `PAYABLE AS ADV @ ${piToApprove.advance_percent || 0
                            }% OF BASIC VALUE`}
                        </td>
                        <td
                          style={{
                            ...styles.cell,
                            textAlign: "right",
                            fontWeight: "bold",
                          }}
                        >
                          {Number(
                            piToApprove.advance_received || 0
                          ).toLocaleString("en-IN", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}
                        </td>
                      </tr>
                    </tbody>
                  </table>

                  {/* Rest of desktop */}
                  <table style={{ ...styles.table, marginTop: "-1px" }}>
                    <tbody>
                      <tr>
                        <td style={styles.cell}>
                          <div style={{ ...styles.bold, color: theme.palette.text.primary }}>
                            In Words: {piToApprove.amount_in_words || "N/A"}
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td style={styles.cell}>
                          {Array.isArray(
                            piToApprove.project?.terms_and_conditions
                          ) &&
                            piToApprove.project.terms_and_conditions.length >
                            0 ? (
                            piToApprove.project.terms_and_conditions
                              .filter(
                                (tc) =>
                                  tc.key === "Jurisdiction" ||
                                  tc.key === "Rejection/Claim" ||
                                  tc.key === "Remark"
                              )
                              .map((tc, index) => (
                                <div key={index} style={{ color: theme.palette.text.primary }}>
                                  {index + 1}. {tc.key}: {tc.value}
                                </div>
                              ))
                          ) : (
                            <>
                              <div style={{ color: theme.palette.text.primary }}>
                                1. Dispute, if any is subject to Raipur
                                Jurisdiction only.
                              </div>
                              <div style={{ color: theme.palette.text.primary }}>
                                2. Interest @22% per annum will be charged after
                                7 days of the presentation of bill.
                              </div>
                            </>
                          )}
                        </td>
                      </tr>
                      <tr>
                        <td style={styles.cell}>
                          <Grid container>
                            <Grid item xs={7}>
                              <div
                                style={{
                                  textDecoration: "underline",
                                  fontWeight: "bold",
                                  color: theme.palette.text.primary,
                                }}
                              >
                                Details for Bank Transfer:-
                              </div>
                              {piToApprove.bank_details ? (
                                <>
                                  <div style={{ marginTop: "5px", color: theme.palette.text.primary }}>
                                    <strong>A/C NO.:</strong>{" "}
                                    {piToApprove.bank_details.account_number ||
                                      "N/A"}
                                  </div>
                                  <div style={{ color: theme.palette.text.primary }}>
                                    <strong>BANK NAME:</strong>{" "}
                                    {piToApprove.bank_details.bank_name ||
                                      "N/A"}
                                    {piToApprove.bank_details.branch_name &&
                                      `, BRANCH - ${piToApprove.bank_details.branch_name}`}
                                  </div>
                                  <div style={{ color: theme.palette.text.primary }}>
                                    <strong>IFSC CODE:</strong>{" "}
                                    {piToApprove.bank_details.ifsc_code ||
                                      "N/A"}
                                  </div>
                                  <div style={{ color: theme.palette.text.primary }}>
                                    <strong>MICR CODE:</strong> N/A
                                  </div>
                                </>
                              ) : (
                                <>
                                  <div style={{ marginTop: "5px", color: theme.palette.text.primary }}>
                                    <strong>A/C NO.:</strong> 22222563453
                                  </div>
                                  <div style={{ color: theme.palette.text.primary }}>
                                    <strong>BANK NAME:</strong> HDFC, BRANCH -
                                    Sun and Suns
                                  </div>
                                  <div style={{ color: theme.palette.text.primary }}>
                                    <strong>IFSC CODE:</strong> AAAA0001ABC
                                  </div>
                                  <div style={{ color: theme.palette.text.primary }}>
                                    <strong>MICR CODE:</strong> N/A
                                  </div>
                                </>
                              )}
                            </Grid>
                            <Grid item xs={5}>
                              <div style={{ color: theme.palette.text.primary }}>
                                Transfer the payment through (NEFT/RTGS) in
                                below account:
                              </div>
                            </Grid>
                          </Grid>
                        </td>
                      </tr>
                    </tbody>
                  </table>

                  <table style={{ ...styles.table, marginTop: "-1px" }}>
                    <tbody>
                      <tr>
                        <td
                          style={{
                            ...styles.cell,
                            width: "50%",
                            textAlign: "center",
                            fontWeight: "bold",
                          }}
                        >
                          OUR GST INFORMATION
                        </td>
                        <td
                          style={{
                            ...styles.cell,
                            width: "50%",
                            textAlign: "center",
                            fontWeight: "bold",
                          }}
                        >
                          AUTHORIZATION
                        </td>
                      </tr>
                      <tr>
                        <td style={{ ...styles.cell, height: "80px" }}>
                          <div style={{ color: theme.palette.text.primary }}>
                            GSTIN: {divisionLocalStorage?.gst_no || "22AAHFK2314C1Z4"}
                          </div>
                          <div style={{ color: theme.palette.text.primary }}>
                            PAN NO.: {divisionLocalStorage?.pan_no || "AAHFK2314C1"}
                          </div>
                        </td>
                        <td
                          style={{
                            ...styles.cell,
                            textAlign: "center",
                            verticalAlign: "bottom",
                          }}
                        >
                          <div style={{ color: theme.palette.text.primary }}>
                            For CRANOIST MHE PVT. LTD.
                          </div>
                          <div style={{ marginTop: "30px", color: theme.palette.text.primary }}>
                            (Signature)
                          </div>
                          <div style={{ color: theme.palette.text.primary }}>
                            Auth. Signatory
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </Box>
              )}
            </Box>
          )}
        </DialogContent>

        {/* Footer */}
        <DialogActions
          sx={{
            p: isMobile ? 1.5 : 2,
            bgcolor: isDark ? theme.palette.grey[900] : "#f5f5f5",
            flexDirection: isMobile ? "column" : "row",
            gap: isMobile ? 1.5 : 2,
            alignItems: "stretch",
            position: "sticky",
            bottom: 0,
            borderTop: `2px solid ${theme.palette.divider}`,
          }}
        >
          <Box
            sx={{
              display: "flex",
              gap: 1,
              width: isMobile ? "100%" : "auto",
              flexDirection: isMobile ? "column" : "row",
            }}
          >
            <Button
              variant="outlined"
              startIcon={<CloseIcon />}
              onClick={() => {
                setApprovalDialogOpen(false);
                setRemarkInput("");
                setPIToApprove(null);
              }}
            >
              Close
            </Button>
          </Box>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ProformaInvoiceTable;